const wrapCharactersInSpan = (text) => {
  return text.split("").map((char, index) => (
    <span key={index} className="char">
      {char}
    </span>
  ));
};

export default wrapCharactersInSpan;
